import React from "react";
import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-content: center;
    margin: ${props => props.theme.spacing};
	max-width: 860px;
    @media (max-width: 767px){
        margin: 0 18px 30px;
    }
`;

export const Title = styled.h4`
    color: #050505;
    font-family: Mallory;
    font-size: 18px;
    font-weight: 900;
    letter-spacing: 1px;
    line-height: 22px;
    margin-bottom: 4px;
    text-align: left;
`;

export const Paragraph = styled.div`
    p {
    color: #212323;
    font-family: Mallory;
    font-size: 16px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 28px;
    margin-bottom: 15px;
    }

    h2 {
        text-transform: none!important;
        display: block!important;
    font-size: 1.5em!important;
    margin-block-start: 0.83em!important;
    margin-block-end: 0.83em!important;
    margin-inline-start: 0px!important;
    margin-inline-end: 0px!important;
    font-weight: bold!important;
    font-family: Mallory!important;
    }

    h3 {
        text-transform: none!important;
        display: block!important;
        font-size: 1.17em!important;
        margin-block-start: 1em!important;
        margin-block-end: 1em!important;
        margin-inline-start: 0px!important;
        margin-inline-end: 0px!important;
        font-weight: bold!important;
    }

    h4 {
        text-transform: none!important;
        color: rgb(5, 5, 5)!important;
    font-family: Mallory!important;
    font-size: 18px!important;
    font-weight: 900!important;
    letter-spacing: 1px!important;
    line-height: 22px!important;
    margin-bottom: 4px!important;
    text-align: left!important;
    }

    h5{
        text-transform: none!important;
        display: block!important;
        font-size: 0.83em!important;
        margin-block-start: 1.67em!important;
        margin-block-end: 1.67em!important;
        margin-inline-start: 0px!important;
        margin-inline-end: 0px!important;
        font-weight: bold!important;
    }

    ol {
        display: block!important;
        list-style-type: decimal!important;
        margin-block-start: 1em!important;
        margin-block-end: 1em!important;
        margin-inline-start: 0px!important;
        margin-inline-end: 0px!important;
        padding-inline-start: 40px!important;
    }

    ul{

        display: block!important;
        list-style-type: disc!important;
        margin-block-start: 1em!important;
        margin-block-end: 1em!important;
        margin-inline-start: 0px!important;
        margin-inline-end: 0px!important;
        padding-inline-start: 40px!important;
    }
`;

export const BodyImageContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 60px;
    @media (max-width: 767px){
        margin-top: 20px;
    }
`

export const Image = styled.img`
    height: 424px;
    width: 668px;
    @media (max-width: 767px){
        width: auto;
        height: auto;
    }
`;